import React from "react";
import { Loader2, ShieldCheck } from "lucide-react";
import { DkimField } from "./GwsBits";

/** Not-yet-connected state: choose join mode / inbound / extras, then connect. */
export function GwsConnectForm({ site, cfg, form, setField, busyKind, onConnect }) {
  const disabled = Boolean(busyKind) || !cfg?.configured || (cfg?.probe && !cfg.probe.ok);
  return (
    <>
      <div className="text-sm text-zinc-400 leading-relaxed">
        Add <span className="mono text-zinc-200">{site.domain}</span> to your Workspace{cfg?.primary_domain ? <> (<span className="mono">{cfg.primary_domain}</span>)</> : null}, then write <strong>the full record set</strong> — verification TXT, Google MX, SPF, DMARC, Gmail shortcut — into Cloudflare and verify ownership with Google. DKIM is the only manual step (Google has no API for it).
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
        <label className="block">
          <div className="label-tiny mb-1.5">Join Workspace as</div>
          <select data-testid="gws-mode-select" value={form.mode} onChange={(e) => setField("mode", e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 rounded-sm px-3 py-2 text-sm outline-none">
            <option value="alias">Domain alias — every existing user gets @{site.domain} (no extra licences)</option>
            <option value="secondary">Secondary domain — separate users/mailboxes (licence each)</option>
          </select>
        </label>
        <label className="block">
          <div className="label-tiny mb-1.5">Inbound mail</div>
          <select data-testid="gws-inbound-select" value={form.inbound} onChange={(e) => setField("inbound", e.target.value)} className="w-full bg-zinc-950 border border-zinc-800 rounded-sm px-3 py-2 text-sm outline-none">
            <option value="workspace">Gmail receives everything — replaces Cloudflare Email Routing MX</option>
            <option value="sending_only">Sending-only — keep Cloudflare Email Routing for inbound</option>
          </select>
        </label>
      </div>
      <label className="flex items-center gap-2 text-xs text-zinc-300 cursor-pointer">
        <input data-testid="gws-mail-cname" type="checkbox" checked={form.mailCname} onChange={(e) => setField("mailCname", e.target.checked)} />
        Add <span className="mono">mail.{site.domain}</span> → Gmail shortcut (CNAME ghs.googlehosted.com)
      </label>
      <DkimField value={form.dkim} onChange={(v) => setField("dkim", v)} optional />
      <button data-testid="gws-connect-btn" onClick={onConnect} disabled={disabled} className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white px-4 py-2 rounded-sm text-sm font-semibold disabled:opacity-50">
        {busyKind === "connect" ? <Loader2 size={14} className="animate-spin" /> : <ShieldCheck size={14} />}
        Add to Workspace &amp; write DNS
      </button>
    </>
  );
}
